import { render, staticRenderFns } from "./IssueInvoiceButton.vue?vue&type=template&id=b6b88a56&"
import script from "./IssueInvoiceButton.vue?vue&type=script&lang=ts&"
export * from "./IssueInvoiceButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports